<div class="image-fullscreen-viewer" (click)="close()">
  <button
    mat-raised-button
    class="close flex items-center justify-center"
    (click)="close()"
    data-test-id="Close Image Fullscreen Viewer"
  >
    <span class="text-uppercase">Close</span>
    <ion-icon name="close-outline" size="large"></ion-icon>
  </button>

  <img [src]="image" (click)="$event.stopPropagation()" />
</div>
